<template>
  <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <form @submit.prevent="handleSubmit">
      <div class="modal-window-header gray">
        <div class="modal-window-heading">
          <h3 class="icon-heading small">
            <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg></span>
            <span v-if="this.auksjon.Auksjonsid">Rediger auksjon: {{this.auksjon.Auksjon}}</span>
            <span v-if="this.auksjonIdentifier && !this.auksjon.Auksjonsid">Laster auksjon...</span>
            <span v-if="!this.auksjonIdentifier">Ny auksjon</span>
          </h3>
        </div>

        <fieldset>
          <div class="grid-x grid-padding-x">
            <TheSelectInput v-model="form.Avdelingsid" containerClassName="cell medium-6 large-6" label="Avdeling" name="Avdelingsid" required v-validate="'required'" data-vv-validate-on="input" :items="instillinger.avdeling"/>
            <TheSelectInput v-model="form.Auksjontype" containerClassName="cell medium-6 large-6" label="Auksjontype" name="Auksjontype" required v-validate="'required'" data-vv-validate-on="input" :items="instillinger.auksjontype"/>
            <TheTextInput containerClassName="cell medium-6 large-6" label="Auksjon" name="Auksjon" v-model.trim="form.Auksjon" maxlength="10" required v-validate="'required|max:10'" :disabled="this.auksjon.Auksjonsid"/>

            <div class="cell medium-6 large-6">
              <label for="Auksjon_dato">Auksjon dato</label>
              <div class="input-container date" :class="{'form-error': errors.has('Auksjon_dato')}">
                <b-datepicker
                  :show-week-number="false"
                  :editable="false"
                  :first-day-of-week="1"
                  v-model="form.Auksjon_dato"
                  v-validate="'required'"
                  required
                  name="Auksjon_dato"
                  placeholder="Vis kalender..."
                  icon="calendar-today"
                  ref="Auksjon_dato"
                  id="Auksjon_dato">
                </b-datepicker>
                <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                <span class="form-error-label" v-if="errors.has('Auksjon_dato')">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                  {{errors.first('Auksjon_dato')}}
                </span>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-body">
        <fieldset>
          <div class="grid-x grid-padding-x">
            <TheTextInput containerClassName="cell medium-12 large-12" label="Beskrivelse" name="Beskrivelse" v-model.trim="form.Beskrivelse" maxlength="50" v-validate="'max:50'"/>
            <TheTextInput containerClassName="cell medium-12 large-12" label="Info" name="Info" v-model.trim="form.Info" maxlength="2000"/>

            <div class="cell">
              <ul class="switch-list">
                <TheSwitchListSwitchInput v-model="form.Locked" labelTrue="Låst" labelFalse="Ikke låst" trueValue="T" falseValue="F"/>
                <TheSwitchListSwitchInput v-model="form.Nettauksjon" labelTrue="Nettauksjon" labelFalse="Ikke nettauksjon" trueValue="T" falseValue="F"/>
              </ul>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-footer">
        <div class="grid-x">
          <div class="cell align-right">
            <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
            <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

            <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()" class="button primary submit large">Lagre</a>
            <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Lagrer...<span class="loader-spinner"></span></a>
            <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Lagre</a>
          </div>
        </div>
      </div>

      <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </form>
  </overlay-scrollbars>
</template>

<script>
import AuksjonService from '@/services/AuksjonService'
import bus from '@/plugins/event-bus'
import moment from 'moment'

export default {
  name: 'AuksjonFormModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    auksjon: {
      type: Object,
      required: false,
      default: function () {
        return {
          Auksjonsid: null
        }
      }
    },
    auksjonIdentifier: {
      type: [Number, String],
      required: false,
      default: null
    }
  },
  data () {
    return {
      form: {},
      instillinger: {
        avdeling: [],
        auksjontype: []
      }
    }
  },
  created () {
    // Set form not submittable
    this.setFormLoading(true)

    if (!this.auksjon.Auksjonsid && this.auksjonIdentifier) {
      this.loadAuksjon()
    } else {
      // Set defaults and load dropdowns
      this.makeFormItem()
      this.fetch()
    }
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()
  },
  methods: {
    loadAuksjon: function () {
      AuksjonService.view(this.auksjonIdentifier)
        .then((response) => {
          // Set key/values to auksjon prop
          this.$helpers.setObjectValues(response.data, this.auksjon)

          // Then make form item and fetch the dropdowns
          this.makeFormItem()
          this.fetch()
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunde ikke laste inn Auksjon')
          this.$emit('close')
        })
    },
    makeFormItem: function () {
      let defaults = {
        Locked: 'F',
        Nettauksjon: 'F',
        Avdelingsid: null,
        Auksjontype: null
      }

      // Aplly defaults and clone
      this.$helpers.setObjectValues(defaults, this.auksjon)

      this.form = this._.cloneDeep(this.auksjon)

      if (this.form.Auksjon_dato) {
        this.form.Auksjon_dato = new Date(Date.parse(this.form.Auksjon_dato))
      }
    },

    fetch: function () {
      // Add a temp item in all dropdowns, where it show that it is loading...
      this.instillinger.avdeling.unshift({key: this.form.Avdelingsid, val: 'Laster...'})
      this.instillinger.auksjontype.unshift({key: this.form.Auksjontype, val: 'Laster...'})

      AuksjonService.loadFormDropdowns()
        .then((data) => {
          this.instillinger.avdeling = data.avdeling
          this.instillinger.avdeling.unshift({key: null, val: 'Velg avdeling', disabled: true})

          this.instillinger.auksjontype = data.auksjontype
          this.instillinger.auksjontype.unshift({key: null, val: 'Velg auksjontype', disabled: true})
        })
        .catch(() => {
          // Skip this error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          // Now submittable again
          this.setFormLoading(false)
        })
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.setFormLoading(false)
        this.$emit('close')
      }
    },
    submitButtonClick: function () {
      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            let data = this._.clone(this.form)

            if (data.Auksjon_dato) {
              const df = new Date(Date.parse(data.Auksjon_dato))
              data.Auksjon_dato = moment(df).format('YYYY-MM-DD 00:00:00')
            }

            AuksjonService.save(this.auksjon.Auksjonsid, data)
              .then((response) => {
                // Show success alert
                this.$helpers.showSuccessAlert('Auksjon er lagret')

                // Emit save ok event
                bus.$emit('auksjon-saved', response.data)

                this.$emit('close')
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
                } else {
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst prøv igjen', 2500)
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/AuksjonFormModal.vue